
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarmerinbanglore() {



  const cardData =
  {
    keyword: 'Patient Warmer in Bengaluru',
    heading: 'Pharmacle Health Care Private Limited: Patient Warmer in Bengaluru',
    headingDescription: 'Pharmacle Health Care Private Limited offers high-quality Patient Warmer in Bengaluru, designed to provide efficient and uniform warming for patients during surgeries and critical care. Our Wallabies Warm Care systems help prevent hypothermia, ensuring enhanced patient safety and comfort. Widely trusted by hospitals and healthcare facilities, our patient warmers are reliable, easy to use, and built with advanced technology. For superior temperature management and better patient outcomes, choose Pharmacle Health Care – the leading provider of patient warmers in Bengaluru.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

    "topPlaces": [
        {
          "title": "Advanced Patient Warmer",
          "description": "Wallabies Warm Care offers high-quality Patient Warmers in Bengaluru, designed to provide optimal thermal regulation during medical procedures, reducing the risk of hypothermia."
        },
        {
          "title": "Forced Air Patient Warmer",
          "description": "Our Forced Air Patient Warmer ensures consistent and controlled temperature regulation for patients in operating rooms, ICUs, and emergency care units."
        },
        {
          "title": "Portable Patient Warmer",
          "description": "The Portable Patient Warmer is an easy-to-use and lightweight warming solution, ideal for hospitals, ambulances, and field medical units."
        },
        {
          "title": "Surgical Patient Warming Device",
          "description": "Designed for preoperative, intraoperative, and postoperative care, our Surgical Patient Warming Device ensures that patients maintain a stable body temperature throughout the surgical process."
        },
        {
          "title": "Neonatal and Pediatric Patient Warmer",
          "description": "Our Neonatal and Pediatric Patient Warmers provide gentle and effective warming for newborns and children, ensuring safe thermal management in NICUs and pediatric wards."
        },
        {
          "title": "ICU Patient Warmer",
          "description": "The ICU Patient Warmer is a critical care device that helps maintain normothermia in patients undergoing intensive medical treatments and recovery."
        },
        {
          "title": "Emergency Medical Warmer",
          "description": "Ideal for trauma care and emergency settings, this warming system prevents hypothermia and ensures faster patient stabilization during critical situations."
        },
        {
          "title": "Veterinary Patient Warmer",
          "description": "Our Veterinary Patient Warmers are designed to provide safe and reliable temperature regulation for animals undergoing medical procedures."
        },
        {
          "title": "Disposable Air Warmer Blankets",
          "description": "Pair our Patient Warmers with Disposable Air Warmer Blankets for a hygienic and efficient warming solution that reduces infection risks."
        },
        {
          "title": "Preoperative and Postoperative Warming System",
          "description": "This system is designed to maintain patient temperature before and after surgery, reducing the chances of complications and ensuring a smoother recovery."
        }
      ],


"services": [
    {
        "name": "Patient Warmer Bengaluru",
        "description": "Pharmacle Health Care Private Limited offers advanced patient warmers in Bengaluru. These devices are designed to ensure optimal body temperature regulation during surgeries and post-operative recovery, preventing hypothermia and enhancing patient comfort."
    },
    {
        "name": "Bengaluru Patient Warming System",
        "description": "Our patient warming systems in Bengaluru are designed to maintain a stable body temperature for patients during medical procedures. These systems help to prevent temperature-related complications and ensure a safe and comfortable experience during treatment."
    },
    {
        "name": "Forced Air Warming Devices Bengaluru",
        "description": "Pharmacle Health Care supplies forced air warming devices in Bengaluru that offer effective temperature control for patients. These devices provide consistent warmth, helping to improve recovery times and ensure patient safety during surgeries and medical treatments."
    },
    {
        "name": "Warming System Bengaluru",
        "description": "We offer reliable warming systems in Bengaluru that are specifically designed for patient care during surgeries, critical care, and recovery. These systems provide controlled warmth to maintain optimal body temperature for patients."
    },
    {
        "name": "Patient Thermoregulation Device Bengaluru",
        "description": "Our patient thermoregulation devices in Bengaluru ensure precise temperature management for patients during medical treatments. These devices are essential in preventing hypothermia and maintaining a stable and safe body temperature."
    },
    {
        "name": "Bengaluru Medical Warming Devices",
        "description": "Pharmacle Health Care provides state-of-the-art medical warming devices in Bengaluru, designed for use in hospitals and clinical settings. These devices ensure that patients are kept at a safe and comfortable temperature during surgeries and critical care."
    },
    {
        "name": "Bengaluru Patient Body Temperature Control",
        "description": "We offer advanced solutions for patient body temperature control in Bengaluru. Our systems are designed to maintain optimal body temperature during medical procedures, preventing hypothermia and improving recovery outcomes for patients."
    }
],
"tableData": [
    ["- Patient Warmer Bengaluru", "- Bengaluru Patient Warming System"],
    ["- Forced Air Warming Devices Bengaluru", "- Warming System Bengaluru"],
    ["- Patient Thermoregulation Device Bengaluru", "- Bengaluru Medical Warming Devices"],
    ["- Bengaluru Patient Body Temperature Control"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers cutting-edge forced air warming systems in Bengaluru, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across Bengaluru."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient warming solutions in Bengaluru, including forced air warming devices, blankets, and temperature control systems. Our solutions are tailored for surgical procedures and critical care, ensuring that your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming equipment is built to the highest standards, ensuring durability and long-term performance. Regularly tested and maintained, our products offer optimal reliability for continuous use in medical environments across Bengaluru."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our forced air warming blankets and devices deliver controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring patients in Bengaluru are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming systems in Bengaluru are flexible and can be integrated into various healthcare settings, including hospitals, clinics, and emergency rooms. We collaborate with healthcare providers to ensure our solutions meet their specific needs, enhancing patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warming solutions are designed for seamless integration with existing medical systems in Bengaluru. Our products are easy to implement, ensuring minimal disruption to ongoing medical procedures while improving operational efficiency."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "Our team in Bengaluru provides expert consultation services to help healthcare facilities select the right warming solutions for their needs. We offer ongoing support and maintenance to ensure that your equipment remains in optimal condition and performs at its best."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are fundamental to our mission. Our warming systems are specifically designed to prevent temperature-related issues during critical medical procedures, ensuring every patient in Bengaluru receives the highest standard of care."
    }
]






  }



  const faqData = [
    { question: "What is a Patient Warmer?", answer: "A Patient Warmer is a medical device designed to maintain or regulate a patient's body temperature during medical procedures by providing controlled warm air through a specialized blanket or pad." },
    { question: "How does the Patient Warmer work?", answer: "The Patient Warmer works by circulating warm air through a blanket or clothing, helping to prevent hypothermia and ensuring the patient's body temperature is kept stable during surgeries or treatments." },
    { question: "Is the Patient Warmer available in Bengaluru?", answer: "Yes, Pharmacle Health Care Private Limited offers the Patient Warmer in Bengaluru, providing healthcare facilities with reliable and efficient temperature regulation solutions for patients." },
    { question: "What are the advantages of using a Patient Warmer?", answer: "It helps in preventing hypothermia, reduces the risk of complications during surgeries, improves recovery times, and enhances overall patient comfort during medical procedures." },
    { question: "How long does the Patient Warmer maintain the patient's body temperature?", answer: "The Patient Warmer can maintain the patient’s temperature for the entire duration of the procedure, providing consistent warmth to ensure patient safety and comfort." },
    { question: "Is the Patient Warmer easy to use?", answer: "Yes, the Patient Warmer is user-friendly and designed to allow healthcare professionals to quickly and easily adjust the settings for optimal patient comfort during treatment." },
    { question: "Can the Patient Warmer be used for different types of surgeries?", answer: "Yes, the Patient Warmer is versatile and can be used for a wide range of medical procedures, especially those where controlling the patient's body temperature is critical." },
    { question: "Is the Patient Warmer safe for all patients?", answer: "Yes, the system is safe for most patients, but it should always be used according to medical guidelines and under the supervision of healthcare professionals to ensure safety." },
    { question: "How can I purchase a Patient Warmer in Bengaluru?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will guide you through the purchasing process and arrange delivery in Bengaluru." },
    { question: "Does Pharmacle Health Care offer support for the Patient Warmer?", answer: "Yes, we provide installation, training, and ongoing maintenance support for our Patient Warmers to ensure they function optimally and reliably." }
  ];
  
  const testimonialsData = [
    {
      text: 'We use the Patient Warmer from Pharmacle Health Care in our Bengaluru clinic, and it has significantly improved patient care during surgeries. It ensures patients are kept warm and comfortable throughout their procedures.',
      name: 'Dr. Asha Reddy',
    },
    {
      text: 'The Patient Warmer by Pharmacle Health Care has been a game-changer in our Bengaluru hospital. The system is easy to use, efficient, and has improved patient outcomes by keeping them at a stable body temperature during surgery.',
      name: 'Dr. Harish Kumar',
    }
  ];
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warmer in Bengaluru",
    "description": "Find top-quality Patient Warmers in Bengaluru designed for effective body temperature control and patient thermoregulation during medical procedures. Our warming devices ensure patient safety and comfort.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1596"
    }
  };
  



  return (
    <div>
  <Helmet>
    <title>Patient Warmer in Bengaluru | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find top-quality Patient Warmers in Bengaluru for body temperature control and thermoregulation during medical treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warmer Bengaluru, Bengaluru Patient Warming System, Forced Air Warming Devices Bengaluru, Warming System Bengaluru, Patient Thermoregulation Device Bengaluru, Bengaluru Medical Warming Devices, Bengaluru Patient Body Temperature Control"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/5.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarmerinbanglore;